'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $("[data-delivery-note-export-save]", this).each(function () {
        $(this).off("click");
        $(this).on("click", function () {
            // Note: .nestable('serialize') will only serialize 1st menu item with its children - 
            // it means that changes are only saved for the 1st menu item, the rest will not be saved;
            // it was decided to leave it as is, but in case if we want to fix it, we'll have to either
            // update serialize method of jquery.nestable plugin or write our own code which will do it 
            // for us properly.
            var hierarchyItems = $("." + $(this).attr("nestable-source")).nestable('serialize');
            console.log(hierarchyItems);
            menuService.updateHierarchy(hierarchyItems).done(function () {
                _notify2.default.success(resx.Common.SettingsSaved);
            }).fail(function () {
                _notify2.default.error(resx.Common.AjaxError);
            });
        });
    });

    $("[menu-items-nestable-cancel]", this).each(function () {
        $(this).off("click");
        $(this).on("click", function () {
            $("#nestableContainer").each(function () {
                loadMenuItems(this);
            });
        });
    });

    $(document).off('click', '[menu-item-button-delete]');
    $(document).on('click', '[menu-item-button-delete]', function () {
        var $deleteBtn = $(this);
        var itemId = $deleteBtn.attr('menu-item-button-delete');
        if (!itemId) return;
        _message2.default.confirm(resx.Common.ConfirmDelete, resx.Messages.ConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                menuService.delete(itemId).done(function () {
                    _notify2.default.success(resx.Common.DeleteSuccess);
                    $("#nestableContainer").each(function () {
                        loadMenuItems(this);
                    });
                }).fail(function () {
                    _notify2.default.error(resx.Common.AjaxError);
                });
            }
        });
    });

    $(document).off('click', '[menu-item-button-is-active]');
    $(document).on('click', '[menu-item-button-is-active]', function () {
        var $btn = $(this);
        var itemId = $btn.attr('menu-item-button-is-active-item-id');
        var isActive = $btn.attr('menu-item-button-is-active') === 'true';
        if (!itemId) return false;
        menuService.setIsActive(itemId, !isActive).done(function () {
            _notify2.default.success(resx.Common.UpdateSuccess);
            updateIsActive(itemId, !isActive);
        }).fail(function () {
            _notify2.default.error(resx.Common.AjaxError);
        });
    });

    $("#nestableContainer", this).each(function () {
        loadMenuItems(this);
    });

    function loadMenuItems(dataNode) {
        var rootNode = $(dataNode);
        menuService.getTopParentsWithChildren().done(function (result) {
            rootNode.html('');
            var nestableRoot = $('<div class="dd menuSettingsNestable" data-nestable menu-settings-nestable></div>');
            var ddList = $('<div></div>');
            nestableRoot.append(ddList);
            rootNode.append(nestableRoot);
            for (var i = 0; i < result.length; i++) {
                var itemNode = $('<div data-id="' + result[i].id + '"></div>');
                itemNode.append($('<div class="dd-item-disabled">' + result[i].name + '</div>'));
                ddList.append(itemNode);
                renderMenuSettingsChildren(itemNode, result[i]);
            }
            nestableRoot.nestable({
                expandBtnHTML: '<button class="btn nestable-button" data-action="expand">+</button>',
                collapseBtnHTML: '<button class="btn nestable-button" data-action="collapse">-</button>',
                dragClass: 'dd-dragel nestable',
                maxDepth: 3
            });
        }).fail(function (result) {
            _notify2.default.error(resx.Common.AjaxError);
        });
    }

    function updateIsActive(itemId, isActive) {
        var isActiveElement = $('li[data-id="' + itemId + '"] > div.is-active');
        isActiveElement.replaceWith($('<div class="is-active ' + (isActive ? 'is-active-yes' : 'is-active-no') + '" />'));
        var isActiveButton = $('a[menu-item-button-is-active-item-id="' + itemId + '"]');
        isActiveButton.replaceWith($('<a menu-item-button-is-active="' + isActive + '" menu-item-button-is-active-item-id="' + itemId + '" class="visible ' + (isActive ? 'visible-dis' : '') + '" href="#"><i class="fa fa-toggle-' + (isActive ? 'on' : 'off') + '"></i></a>'));
    }

    function renderMenuSettingsChildren(itemNode, item) {
        if (!item || !item.items || !item.items.length) {
            return;
        }
        var ddList = $('<ol class="dd-list"></ol>');
        itemNode.append(ddList);
        for (var i = 0; i < item.items.length; i++) {
            var liNode = $('<li class="dd-item" data-id="' + item.items[i].id + '">');
            ddList.append(liNode);
            var isActive = item.items[i].isActive;
            liNode.append($('<div class="is-active ' + (isActive ? 'is-active-yes' : 'is-active-no') + '" />'));
            liNode.append($('<a class="edit" title="Upravit" href="' + linksoft.url.menuSettings(item.items[i]) + '"><i class="fa fa-edit"></i></a>'));
            liNode.append($('<a class="copy" data-toggle="modal" data-target="#copy-item" data-control-button-copy-select="' + item.items[i].id + '" href=""><i class="fa fa-copy"></i></a>'));
            liNode.append($('<a menu-item-button-is-active="' + isActive + '" menu-item-button-is-active-item-id="' + item.items[i].id + '" class="visible ' + (isActive ? 'visible-dis' : '') + '" href="#"><i class="fa fa-toggle-' + (isActive ? 'on' : 'off') + '"></i></a>'));
            liNode.append($('<a menu-item-button-delete="' + item.items[i].id + '" data-confirm="Common:ConfirmDelete" class="remove" href="#"><i class="fa fa-remove"></i></a>'));
            liNode.append($('<div class="dd-handle">' + item.items[i].name + '</div>'));
            renderMenuSettingsChildren(liNode, item.items[i]);
        }
    }
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Common", "Messages", "App");

var $ = require("jquery");
var menuService = abp.services.api.menu;

;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/nestable.js
// module id = 443
// module chunks = 0